import { buildTranslate } from 'locales'
import {
  formatDate as formatDateRaw,
  formatDateTime as formatDateTimeRaw,
  formatTime as formatTimeRaw,
} from 'utilities/dateFormatters'

const t = buildTranslate('order_ratings.rating_detail')

// Leaf module for the ratings-detail formatters: extracted so both the customer
// panels sub-hook and the scene can import `formatDate` without an import cycle
// through the controller hook. Each wraps utilities/dateFormatters with the same
// empty policy — no timestamp → em-dash, unparseable → the raw string, so a bad
// value is visible rather than silently blank.

// Date + time, for the header subtitle and the Case detail's "Date & time" row.
export const formatDateTime = (iso: string | null): string =>
  iso ? formatDateTimeRaw(iso) || iso : t('empty')

// Date-only, for the recent-activities table's "Date" column (same policy).
// Also the scene's RecentActivitiesTable `formatDate` prop.
export const formatDate = (iso: string | null): string =>
  iso ? formatDateRaw(iso) || iso : t('empty')

// Time-only, for the Case timeline's synthesized steps (same policy).
export const formatTime = (iso: string | null): string =>
  iso ? formatTimeRaw(iso) || iso : t('empty')
